import React from 'react'
import { Dropdown, Row, Button, Divider } from 'antd'

import { apiFetch } from 'zn-common'
import { logout } from '@common/utils/utils'

import arrow from '../img/arrow.png'

export default function UserInfo(props) {
  const { styles, userName, setEditVisible } = props
  const turnConsole = () => {
    const isDev = process.env.NODE_ENV === 'development'
    window.open(isDev ? 'http://localhost:8003/#/' : '/console/#/')
  }
  return (
    <div className="fn font16 frn pointer">
      <Dropdown placement="bottom" overlay={(
        <div className={styles.dropdownMenu}>
          <Row>
            <Button type="text" onClick={() => turnConsole()}>进入控制台</Button>
            <img className={styles.colarrow} src={arrow}/>
          </Row>
          <Divider className={styles.dividerLine} />
          {/* <Row><Button type="text" onClick={() => setAgentInfoVisible(true)}>合作商信息</Button></Row>
                    <Divider style={{margin: '8px 0'}} /> */}
          <Row>
            <Button className={styles.rowline} type="text" onClick={() => setEditVisible(true)}>修改</Button>
            <Button className={styles.left17} type="text" onClick={() => {logout(() => apiFetch({ url: 'logout.do', method: 'GET',}))}}>退出</Button>
          </Row>
        </div>
      )}
      >
        <div className={`flex aic ${styles.dropdownTrogger}`}>
          <div className="font14" style={{ lineHeight: '20px', marginRight: '10px' }}>{userName}</div>
          <img src={arrow} className={styles.rowarrow}/>
        </div>
      </Dropdown>
    </div>
  )
}